import React from "react";

import { Switch, Route, withRouter } from "react-router-dom";

import Settings from "./settings/settings"
import Appointments from "./appointments/appointments"

function Router( { history, base } ) {
  
  return (
    <Switch>
      <Route path={`${base}/settings`}>
        <Settings/>
      </Route>
      <Route path={`${base}/appointments`}>
        <Appointments/>
      </Route>
    </Switch>
  );

}

export default withRouter(Router);
